<template>
  <div class="home">
    <div class="banner min-container">
      <!-- <el-carousel :autoplay="false" trigger="click" height="410px">
        <el-carousel-item v-for="item in 2" :key="item">
          <div class="banner_img"></div>
        </el-carousel-item>
      </el-carousel> -->
      <swiper :options="swiperBannerOption">
        <swiper-slide
          v-for="(item, index) in 1"
          :key="index"
          style="height: 410px;"
        >
          <!-- <a :style="item.style" class="banner_img" target="_blank"></a> -->
          <div
            class="banner_img"
            aria-label="banner_img"
            @click="toppwc"
          >
            <div
              class="container"
              style="position:relative;"
            >
              <!--              <div class="banner_btn">-->
              <!--                <p>{{ $t('ppwc.p104') }}</p>-->
              <!--              </div>-->
            </div>
          </div>
        </swiper-slide>
        <!-- <div v-if="banner.length > 1" class="swiper-button-prev" slot="button-prev"></div>
        <div v-if="banner.length > 1" class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
    </div>
    <div class="top min-container">
      <div class="container">
        <!-- <div class="top_title">
          <a
            :class="{highlight: eventName === 'upcoming'}"
            @click="eventName='upcoming'"
          >{{ $t('common.p58') }}</a>
          <a
            :class="{highlight: eventName === 'pastevent'}"
            @click="eventName='pastevent'"
          >{{ $t('common.p60') }}</a>
        </div> -->

        <el-tabs
          v-model="eventName"
        >
          <!-- <el-tab-pane
            :label="$t('common.p58')"
            name="upcoming"
          /> -->
          <el-tab-pane
            :label="$t('common.p60')"
            name="pastevent"
          />
        </el-tabs>
      </div>
    </div>

    <div
      v-if="eventName === 'upcoming'"
      class="middle min-container"
    >
      <events-home />
    </div>
    <div
      v-else
      class="middle min-container"
    >
      <div class="center">
        <el-tabs v-model="activeName">
          <el-tab-pane
            :label="$t('common.p61')"
            name="first"
            class="first"
          >
            <div v-if="report">
              <div class="container">
                <div>
                  <h3 class="ui header per-header home-color">
                    VIDEO REVIEW
                  </h3>
                </div>

                <div>
                  <video
                    id="player"
                    ref="video"
                    poster="/official/static/img/events/home_video.jpg"
                    playsinline
                    controls
                  >
                    <source
                      :src="'/official/static/img/events/ppwc_pc.mp4'"
                      type="video/mp4"
                    >Your browser does not support the video tag.
                  </video>
                </div>
              </div>

              <div class="all_days_bg_top" />

              <div class="all_days_bg">
                <div class="container">
                  <h3 class="ui header per-header">
                    {{ $t('common.p63') }}
                  </h3>
                </div>
                <div class="all_days container">
                  <div class="row">
                    <div class="column">
                      <a @click="toReportCon(1)">
                        <img
                          class="ui image"
                          src="/official/static/img/events/1.jpg"
                        >
                      </a>
                    </div>
                    <div class="column">
                      <a @click="toReportCon(2)">
                        <img
                          class="ui image"
                          src="/official/static/img/events/2.jpg"
                        >
                      </a>
                    </div>
                    <div class="column">
                      <a @click="toReportCon(3)">
                        <img
                          class="ui image"
                          src="/official/static/img/events/3.jpg"
                        >
                      </a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="column">
                      <a @click="toReportCon(4)">
                        <img
                          class="ui image"
                          src="/official/static/img/events/4.jpg"
                        >
                      </a>
                    </div>
                    <div class="column">
                      <a @click="toReportCon(5)">
                        <img
                          class="ui image"
                          src="/official/static/img/events/5.jpg"
                        >
                      </a>
                    </div>
                    <div class="column">
                      <a @click="toReportCon(6)">
                        <img
                          class="ui image"
                          src="/official/static/img/events/6.jpg"
                        >
                      </a>
                    </div>
                  </div>
                  <div class="ui columns grid final_day">
                    <div class="column">
                      <a @click="toReportCon(7)">
                        <img
                          class="ui image"
                          src="/official/static/img/events/7.jpg"
                        >
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="all_days_bg_bottom" />

              <div class="about_ppwc_bg">
                <div class="container">
                  <div class="sixteen wide column col-about">
                    <h3
                      style="color: #1f9d56"
                      class="ui header per-header"
                    >
                      {{ $t('common.p64') }}
                    </h3>
                  </div>

                  <div class="con2">
                    <p style="color: #727272;">
                      {{ $t('event.p2') }}
                    </p>
                    <p style="color: #727272;">
                      {{ $t('event.p3') }}
                    </p>
                    <img src="/official/static/img/events/picture_logo_ppwc.svg">
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else
              class="report_con container"
            >
              <div class="left">
                <div
                  class="left_item bg-color home-p-color"
                  @click="report = true"
                >
                  {{ $t('common.p63') }}
                </div>
                <div
                  v-for="(item, index) in items"
                  :key="index"
                  class="left_item bg-color home-p-color"
                  :class="{ highlight: item.index === report_index}"
                  @click="report_index = item.index"
                >
                  <p>{{ item.name }}</p>
                </div>
              </div>
              <div class="right bg-color home-p-color">
                <img
                  v-for="item in images"
                  :key="item"
                  class="img_report"
                  :src="'/official/static/img/events/' + item + '.jpg'"
                >
                <a
                  target="_blank"
                  href="https://www.facebook.com/PPPokerPTC/?__tn__=%2Cd%2CP-R&eid=ARCW_uVKvJzlYIsQVUQS0_lxA46n62N2Q_nxBbXsENHGx5RIohTS4xmZk-ff2R4CRDwWorkoZ2dc4fEn"
                >
                  <img
                    class="more_detail"
                    src="/official/static/img/events/facebook.png"
                  >
                </a>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :label="$t('common.p62')"
            name="second"
            class="second"
          >
            <div
              v-show="result_status"
              class="result_home container"
            >
              <el-table :data="schedule">
                <el-table-column
                  prop="date"
                  label="Time"
                  align="center"
                />
                <el-table-column
                  prop="event"
                  label="Event#"
                  align="center"
                />
                <el-table-column
                  prop="name"
                  label="Name"
                  align="center"
                  min-width="250"
                />
                <el-table-column
                  label="Buy in(PHP)"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div>{{ scope.row.buyin | formatZero }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Tournament Info"
                  width="290"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div>
                      <a
                        target="_blank"
                        :href="'https://pppoker.net/privacyPolicy.html/images/' + encodeURIComponent(scope.row.images[0])"
                        style="margin-right: 10px;"
                      > <el-button type="success">{{ $t('common.p70') }}</el-button></a>
                      <a
                        v-if="scope.row.state != '3'"
                      ><el-button
                        type="info"
                        disabled
                      >{{ $t('common.p71') }}</el-button></a>
                      <a
                        v-else
                        @click="toResultCon(scope.row.id)"
                      ><el-button type="success">{{ $t('common.p71') }}</el-button></a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="!result_status"
              class="result_con bg-p-color container"
            >
              <div class="left">
                <div
                  class="left_item bg-color"
                  @click="result_status = true"
                >
                  PPWC RESULT
                </div>
                <div
                  v-for="(item, index) in schedule"
                  :key="index"
                  class="left_item bg-color"
                  :class="{ highlight: item.id === result_index}"
                  @click="toResultCon(item.id)"
                >
                  <p>{{ item.name }}</p>
                </div>
              </div>
              <div class="right bg-color">
                <h2 class="ui header home-color">
                  {{ result.title }}
                </h2>
                <p v-html="result.content" />
                <img
                  class="ui image"
                  :src="result.images[0]"
                >
                <br>
                <p>The following is a list of awards for {{ result.name }} Event:</p>
                <el-table
                  :data="result.result"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="rank"
                    label="RANK"
                    align="center"
                  />
                  <el-table-column
                    prop="name"
                    label="NAME"
                    align="center"
                  />
                  <el-table-column
                    prop="platform"
                    label="PLATFORM"
                    align="center"
                  />
                  <el-table-column
                    prop="prizes"
                    label="PRIZES"
                    align="center"
                  />
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import eventsHome from './eventsHome.vue'

export default {
  components: {
    swiper,
    swiperSlide,
    eventsHome
  },
  filters: {
    formatZero (data) {
      if (data === '0') {
        return '-'
      } else {
        return (data || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      }
    },
    formatZeroMobile (data) {
      if (data === '0') {
        return '-'
      } else {
        return (
          'PHP ' + (data || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        )
      }
    }
  },
  data () {
    return {
      swiperBannerOption: {
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: true
        // },
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      eventName: 'pastevent',
      activeName: 'first',
      report: true,
      items: [
        { name: 'Day1', index: '1' },
        { name: 'Day2', index: '2' },
        { name: 'Day3', index: '3' },
        { name: 'Day4', index: '4' },
        { name: 'Day5', index: '5' },
        { name: 'Day6', index: '6' },
        { name: 'Final Day', index: '7' }
      ],
      report_index: '1',
      result_status: true,
      result_index: '1',
      schedule: [],
      result: {
        images: []
      },
      page: {
        now: 1,
        total: 1,
        per_num: 10
      }
    }
  },
  computed: {
    images: function () {
      let nums = {
        pc: {
          '1': ['1_01', '1_02', '1_03', '1_04', '1_05', '1_06', '1_07'],
          '2': ['2_01', '2_02', '2_03', '2_04', '2_05', '2_06', '2_07'],
          '3': [
            '3_01',
            '3_02',
            '3_03',
            '3_04',
            '3_05',
            '3_06',
            '3_07',
            '3_08',
            '3_08',
            '3_10'
          ],
          '4': ['4_01', '4_02', '4_03', '4_04', '4_05', '4_06', '4_07'],
          '5': ['5_01', '5_02', '5_03', '5_04', '5_05', '5_06', '5_07'],
          '6': ['6_01', '6_02', '6_03', '6_04', '6_05', '6_06', '6_07', '6_08'],
          '7': ['7_01', '7_02', '7_03', '7_04', '7_05', '7_06', '7_07']
        }
      }
      let desize = 'pc'

      return nums[desize][this.report_index].map(item => {
        return desize + '/' + this.report_index + '/images/' + item
      })
    }
  },
  created () {
    this.$store.commit('changeTab', '/events')
    this.getlist()
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    toppwc () {
      // window.open('https://thelivepoker.com//ppwc')
    },
    getlist () {
      this.$axios
        .get('/poker-api/competition/schedules')
        .then(res => {
          console.log(res)
          if (res.status === 200 && res.data.code === 0) {
            this.schedule = res.data.data
            this.page.total = Math.ceil(
              res.data.data.length / this.page.per_num
            )
          } else {
            alert('network issue, Please try again later.')
          }
        })
        .catch(() => {
          alert('network issue, Please try again later.')
        })
    },
    updateResultCon (id) {
      this.$axios
        .get('/poker-api/competition/result', {
          params: {
            id
          }
        })
        .then(res => {
          console.log(res)
          if (res.status === 200 && res.data.code === 0) {
            this.result = res.data.data.result || {
              images: []
            }
          } else {
            alert('network issue, Please try again later.')
          }
        })
        .catch(() => {
          alert('network issue, Please try again later.')
        })
    },
    changePage (page) {
      this.page.now += page
    },
    toReportCon (num) {
      this.report = false
      this.report_index = num.toString()
      document.querySelector('.middle').scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    toResultCon (id) {
      console.log(id)
      this.result_status = false
      this.result_index = id
      this.updateResultCon(id)
      document.querySelector('.middle').scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  padding: 0;
  .banner {
    position: relative;
    height: 410px;
    z-index: 1;
    background-color: #000;
    .banner_img {
      height: 410px;
      background: url("/official/static/img/events/banner1.jpg") center center;
      background-repeat: no-repeat;
      //cursor: pointer;
      .banner_btn {
        position: absolute;
        width: 256px;
        height: 70px;
        left: 178px;
        top: 223px;
        background: url("/official/static/img/events/banner_btn.png") center center;
        background-repeat: no-repeat;
        text-align: center;
        cursor: pointer;
        p {
          line-height: 53px;
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
    /deep/.el-carousel__arrow {
      font-size: 30px;
    }
    .swiper-button-prev {
      background: url("/official/static/img/home/arrow_l.png") center center;
      background-size: 100%;
    }
    .swiper-button-next {
      background: url("/official/static/img/home/arrow_r.png") center center;
      background-size: 100%;
    }
  }
  .top {
    position: relative;
    width: 100%;
    height: 57px;
    background-color: #000000;
    /deep/.el-tabs__header {
      margin-bottom: 0px;
    }
    /deep/.el-tabs__item {
      color: #cccccc;
      font-size: 18px;
    }
    /deep/.el-tabs__nav-wrap.is-top {
      // display: inline-block;
      width: auto;
      padding-top: 7px;
      background-color: #000;
    }
    /deep/.el-tabs__nav-scroll {
      width: 1200px;
      margin: 0 auto;
    }
    /deep/.el-tabs__nav.is-top {
      transform: translateX(0%)!important;
      padding: 0 10px;
    }
    /deep/.el-tabs__nav-wrap::after {
      background-color: #cccccc;
      height: 0px;
    }
    /deep/.el-tabs__item.is-top.is-active {
      color: #1f9d56;
      // font-weight: bold;
    }
    /deep/.el-tabs__active-bar {
      background-color: #1f9d56;
      padding-right: 20px;
      height: 0px;
      margin-bottom: -1px;
      border-bottom: 5px solid #1f9d56;
    }
    /deep/.el-tabs__item {
      height: 50px;
    }
    // .top_title {
    //   font-size: 18px;
    //   color: #fff;
    //   a {
    //     cursor: pointer;
    //     line-height: 57px;
    //     color: #cccccc;
    //     margin: 0 20px;
    //   }
    //   a:nth-child(1) {
    //     margin-left: 0px;
    //   }
    //   .highlight {
    //     color: #1f9d56;
    //     border-bottom: 3px solid #1f9d56;
    //   }
    // }
  }
  .middle {
    // color: #fff;
    position: relative;
    background-color: #fff;
    padding: 65px 0px 0px 0px;
    /deep/.el-tabs__item {
      color: #cccccc;
      font-size: 24px;
    }
    /deep/.el-tabs__nav-wrap.is-top {
      display: inline-block;
      width: auto;
    }
    /deep/.el-tabs__nav.is-top {
      transform: translateX(0%)!important;
      padding: 0 19px;
    }
    /deep/.el-tabs__item.is-top.is-active {
      color: #1f9d56;
      font-weight: bold;
    }
    /deep/.el-tabs__nav-wrap::after {
      background-color: #cccccc;
    }
    /deep/.el-tabs__active-bar {
      background-color: #1f9d56;
      padding-right: 40px;
      height: 2px;
      margin-bottom: -1px;
    }
    /deep/.el-tabs__item {
      height: 50px;
    }
    .upcoming-content {
      line-height: 30px;
    }
    .first {
      video {
        width: 100%;
      }
      .per-header {
        font-size: 32px;
        text-align: left;
        margin: 0px;
        padding: 32px 0px;
      }
      .all_days_bg {
        background: url('/official/static/img/events/bg_g_middle.png') no-repeat center top;
        height: 1296px;
        margin-top: 40px;
        padding-top: 50px;
      }
      .all_days .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;
        .column {
          width: 31.5%;
          img {
            width: 100%;
            display: inline-block;
            cursor: pointer;
          }
        }
      }
      .final_day {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 0px 30px 0px;
        .column {
          width: 100%;
          img {
            width: 100%;
            display: inline-block;
            cursor: pointer;
          }
        }
      }
      .about_ppwc_bg {
        background: url('/official/static/img/events/bg_logo.jpg') no-repeat right top;
        width: 100%;
        // height: 1073px;
        padding: 0px;
        margin-top: -70px;
        padding-bottom: 50px;
      }
      .con2 {
        text-align: left;
        margin: 10px 0px 0px 0px;
        p {
          font-size: 17px;
          line-height: 24px;
          margin-bottom: 10px;
        }
        img {
          margin-top: 30px;
          width: 100%;
        }
      }
      .report_con {
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        margin-top: 65px;
        min-height: 1000px;
        padding-bottom: 70px;
        .left {
          position: relative;
          display: inline-block;
          width: 224px;
          .left_item {
            width: 220px;
            height: 55px;
            // background-color: #242424;
            margin-bottom: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            p {
              font-size: 15px;
              max-width:100%;
            }
          }
          .highlight {
            background-color: #58b26d;
            color: #fff;
          }
        }
        .right {
          position: relative;
          width: 822px;
          display: inline-block;
          // background-color: #000;
          // background-color: #242424;
          min-height: 600px;
          padding: 50px 67px;
          img {
            width: 100%;
            display: block;
          }
          .more_detail {
            position: absolute;
            width: 164px;
            bottom: 85px;
            left: 50%;
            margin-left: -82px;
            display: block;
          }
        }
      }
    }
    .second {
      padding-bottom: 70px;
      .result_home {
        .el-table::before, .el-table {
          background-color: inherit;
          color: #727272;
          font-size: 16px;
          margin-top: 40px;
        }
        /deep/.el-table .el-button--success {
          background-color: #1f9d56;
          border-color: #1f9d56;
        }
        /deep/.el-table td, /deep/.el-table th.is-leaf {
          border-color: #bebebe;
        }
        /deep/.el-table th, /deep/.el-table tr {
          background-color: inherit;
        }
        /deep/.el-table th, /deep/.el-table tr {
          &:hover {
            background-color: inherit;
          }
        }
        /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
          background-color: inherit;
        }
      }
      .result_con {
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        margin-top: 50px;
        // min-height: 1000px;
        // padding-bottom: 65px;
        .left {
          position: relative;
          display: inline-block;
          width: 224px;
          .left_item {
            width: 220px;
            height: 55px;
            // background-color: #242424;
            margin-bottom: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            p {
              font-size: 15px;
              max-width: 100%;
            }
          }
          .highlight {
            background-color: #58b26d;
            color: #fff;
          }
        }
        .right {
          position: relative;
          text-align: left;
          width: 868px;
          display: inline-block;
          padding: 52px 44px;
          h2.ui.header {
            font-size: 38px;
            margin: 0px;
          }
          img {
            max-width: 100%;
          }
          p {
            font-size: 18px;
            margin: 18px 0px;
          }
          .el-table::before, .el-table {
            background-color: inherit;
            font-size: 16px;
            margin-top: 40px;
          }
          /deep/.el-table .el-button--success {
            background-color: #1f9d56;
            border-color: #1f9d56;
          }
          /deep/.el-table td, /deep/.el-table th.is-leaf {
            border-color: #bebebe;
          }
          /deep/.el-table th, /deep/.el-table tr {
            background-color: inherit;
          }
          /deep/.el-table th, /deep/.el-table tr {
            &:hover {
              background-color: inherit;
            }
          }
          /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
            background-color: inherit;
          }
          /deep/p {
            color: #727272!important;
          }
        }
      }
    }
  }
}
</style>
